export default __webpack_public_path__ + "static/media/Mini_Grey.12c7d480.svg";